export default "__VITE_ASSET__BGv6fwnv__";